// /src/renderer/shared/components/Table/TableCell.tsx
import React from "react";
// import "./TableCell.scss";
import styles from "./TableCell.module.scss";

export interface TableCellProps {
  className?: string;
  children?: React.ReactNode;
  isDesc?:boolean;
}

function TableCell({ className = "", children,isDesc=false }: TableCellProps): React.JSX.Element {
  return (
    <td className={`${styles.cell} ${isDesc?styles.fixed:''}${className}`}>
      {children}
    </td>
  );
}

export default TableCell;
